import RadioGroup from "@material-ui/core/RadioGroup";
import styled from "styled-components";

export default styled(RadioGroup)`
  flex-direction: ${({ direction }) => direction};
`;
